export class MedicalRequestDataModel {
    REQUEST_NO: string;

    REQUEST_DATE: string;

    PATIENT_ID: string;

    COSTCENTER_CODE: string;

    DOCTOR_CODE: string;
DOCTOR_NAME: string;
    REQUIREDBY_DATE: string;

    REQUIREDBY_TIME: string;

    PRIORITY: string;

    LANGUAGE_CODE: string;

    REMARKS: string;

    STATUS: string;  

    REPORT_TYPE: string;
	REPORT_NO:string;

    REQUESTOR_RELATION: string;

    REQUESTOR_NAME: string;

    REQUESTOR_EMAIL: string;

    REQUESTOR_MOBILENO: string;

    COLLECTOR_RELATION: string;

    COLLECTOR_NAME: string;

    COLLECTOR_EMAIL: string;

    COLLECTOR_MOBILE_NO: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/MedicalRequest/MedicalRequestDataModel.ts